import React from 'react';
import { RiArrowDropDownLine } from "react-icons/ri";
import { Link } from 'react-router-dom';
const Navbar = () => {
  return (
    <>
         <nav className="flex bg-primaryColor items-center justify-between text-center bg-gray-light">
           <div className='container mx-auto'>
            <ul className="flex items-center justify-center">
                <li className='p-4 lg:px-8 hover:text-gray-600' ><Link to="/" >Home</Link></li>
                    
                <li className='p-4 lg:px-8 hover:text-gray-600'><Link to="/products">Products</Link></li>
                
                <li className='p-4 lg:px-8 hover:text-gray-600'>
                <div className="group relative">
                    <button className="py-2 px-4 inline-flex items-center">
                    <span className="mr-1">Categories</span>
                    <RiArrowDropDownLine size={30} />
                    </button>
                    <div tabIndex="0" className="border border-1 bg-white invisible border-gray-800  w-60 absolute left-0 top-full transition-all opacity-0 group-focus-within:visible group-focus-within:opacity-100 group-focus-within:translate-y-1">
                        <ul className="py-1">
                            <li>
                                <a href="?"className="block px-4 py-2 hover:bg-gray-100">
                                Men's Fashion
                                </a>
                            </li>
                            <li>
                                <a href="?"className="block px-4 py-2 hover:bg-gray-100">
                                Women's Fashion
                                </a>
                            </li>
                            <li>
                                <a href="?"className="block px-4 py-2 hover:bg-gray-100">
                                Electronics
                                </a>
                            </li>
                            <li>
                                <a href="?"className="block px-4 py-2 hover:bg-gray-100">
                                Home & Garden
                                </a>
                            </li>
                            <li>
                                <a href="?"className="block px-4 py-2 hover:bg-gray-100">
                                Sports
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                </li>
                <li className='p-4 lg:px-8 hover:text-gray-600'>About Us</li>
                <li className='p-4 lg:px-8 hover:text-gray-600'>Contact Us</li>
            </ul>
            </div>

        </nav>

      </>
   
  )
}

export default Navbar